exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-1071371a]{font-weight:bold;font-size:18px}.avatar-uploader[data-v-1071371a]{height:130px}.avatar-uploader .el-upload[data-v-1071371a]{border:1px dashed #f7f7f7;border-radius:10px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-1071371a]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-1071371a]{font-size:28px;color:#8c939d;width:130px;height:130px;line-height:130px;text-align:center}.avatar_img[data-v-1071371a]{width:130px;height:130px;border-radius:6px;display:block}", ""]);

// exports
